import styled from 'styled-components';

export default styled.div`
  > div {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;

    > * {
      min-width: 16rem;
    }
  }
`;
